import React, { useContext, useState } from 'react';
import { Row, Col, Form, Tabs, Modal } from 'antd';
import {
  Button,
  Checkbox,
  Input,
  Layout,
  MessageSteps,
  SelectFile,
  Footer,
} from 'components';

import MessagesSummary from '../../Messages/messages-summary';

import ArrowRight from '../../../assests/icons/arrow-right';
import IdentityIcon from '../../../assests/icons/identitiy.icon';
import ProfileIcon from '../../../assests/icons/profile.icon';
import CompanyIcon from '../../../assests/icons/company.icon';
import UploadIcon from '../../../assests/icons/upload.icon';

import '../../Messages/message-steps/steps.less';
import './create-title-step-1.less';
import ArrowLeft from '../../../assests/icons/arrow-left';
import { DimensionsContext } from '../../../context/dimensions.context';

const titleList = ['ünvan 1', 'ünvan2', 'ünvan 3'];

const createTitleSteps = [
  {
    text: 'Kimlik',
    icon: <IdentityIcon />,
  },
  {
    text: 'Şirket',
    icon: <CompanyIcon />,
  },
  {
    text: 'Ünvan',
    icon: <ProfileIcon />,
  },
];

const ChooseTitle = () => {
  const [selectTitleModal, setSelectTitleModal] = useState(false);
  const { isPc } = useContext(DimensionsContext);
  const [form] = Form.useForm();

  const [valid, setValid] = useState(false);

  const onLoginFormSubmit = (values) => {
    console.log('Success:', values);
  };

  const onValuesChange = () => {
    setTimeout(() => {
      let inputs = form.getFieldsError();

      for (var i = 0; i < inputs.length; i++) {
        let formItemName = inputs[i]['name'][0];
        if (checkError(formItemName)) {
          setValid(true);
        } else {
          setValid(false);
          break;
        }
      }
    }, 10);
  };

  const checkError = (fieldName) => {
    if (
      form.isFieldTouched(fieldName) &&
      form.getFieldError(fieldName).length === 0
    ) {
      return true;
    }
  };

  return (
    <Layout
      customMenuRender={() => (
        <MessageSteps items={createTitleSteps} current={1} status="process" />
      )}
    >
      <div className="create-title-step-page">
        <Form
          form={form}
          name="create-title-step-2"
          onFinish={onLoginFormSubmit}
          onValuesChange={onValuesChange}
        >
          <div className="step-transitions">
            <div className="container">
              <div className="step-transitions_left"></div>
              {isPc ? (
                <div className="step-transitions__right">
                  <Button
                    type="ghost"
                    className="circle"
                    href="./CreateTitleStep1"
                  >
                    <ArrowLeft />
                  </Button>
                  <Button
                    type="primary"
                    shape="round"
                    htmlType="submit"
                    className="ant-btn--icon"
                    onClick={() => {
                      setSelectTitleModal(true);
                    }}
                    disabled={!valid}
                  >
                    Ünvanınızı Seçiniz
                    <ArrowRight />
                  </Button>

                  <Modal
                    title="Ünvan Seçin"
                    visible={selectTitleModal}
                    onCancel={() => setSelectTitleModal(false)}
                    footer={[
                      <div className="modal-action">
                        <Button
                          shape="round"
                          type="ghost"
                          onClick={() => setSelectTitleModal(false)}
                        >
                          Vazgeç
                        </Button>
                        <Button
                          key="confirm"
                          type="primary"
                          href={'../Title/success'}
                          onClick={() => {
                            setSelectTitleModal(false);
                          }}
                        >
                          Onaya Gönder
                        </Button>
                      </div>,
                    ]}
                  >
                    <div>
                      <Form form={form} name="choose-title">
                        <Form.Item
                          rules={[{ required: true }]}
                          name="title"
                          messageVariables={{ label: 'title' }}
                        >
                          <Input
                            type="text"
                            name="Title"
                            label="Ünvanınız"
                            info={
                              <span>
                                Telefonda mesaj başlığı olarak görünecek
                                gönderen ismi.
                              </span>
                            }
                          />
                        </Form.Item>
                        <Form.Item
                          name="mail"
                          messageVariables={{ label: 'e-mail' }}
                        >
                          <Input
                            type="mail"
                            name="mail"
                            label="Mail Adresiniz"
                          />
                        </Form.Item>
                        <Form.Item name="chekbox" messageVariables="checkbox">
                          <Checkbox
                            text={
                              <>
                                <a href="javascript:;">Sözleşme</a>yi okudum,
                                kabul ediyorum ve yukarıdaki e-mail adresime
                                gönderilmesini talep ediyorum.
                              </>
                            }
                          />
                        </Form.Item>
                      </Form>
                    </div>
                  </Modal>
                </div>
              ) : null}
            </div>
          </div>
          <div className="page-content">
            <div className="container">
              <Row>
                <Col md={24} lg={16} xl={16} span={24}>
                  <div className="page-content__left">
                    <div>
                      <h3 className="box__title">Şirket Bilgileri</h3>
                      <Row gutter={20}>
                        <Col sm={12} md={12} lg={12} xl={12} span={24}>
                          <Form.Item
                            rules={[{ required: true }]}
                            name="institution-name"
                            messageVariables={{ label: 'name' }}
                          >
                            <Input
                              type="text"
                              label="Kurum Adı"
                              name="institution-name"
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={20}>
                        <Col sm={12} md={12} lg={12} xl={12} span={24}>
                          <Form.Item
                            rules={[{ required: true }]}
                            name="tax-administration"
                            messageVariables={{ label: 'name' }}
                          >
                            <Input
                              type="text"
                              label="Vergi Dairesi"
                              name="tax-administration"
                            />
                          </Form.Item>
                        </Col>
                        <Col sm={12} md={12} lg={12} xl={12} span={24}>
                          <Form.Item
                            rules={[{ required: true }]}
                            name="tax-number"
                            messageVariables={{ label: 'name' }}
                          >
                            <Input
                              type="text"
                              label="Vergi Numarası"
                              name="tax-number"
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>
                    <div>
                      <h3 className="box__title">Gerekli Belgeler</h3>
                      <Row gutter={20}>
                        <Col sm={24} md={24} lg={24} xl={24} span={24}>
                          <Form.Item
                            rules={[{ required: true }]}
                            name="add-document"
                            messageVariables={{ label: 'file-document' }}
                          >
                            <SelectFile
                              allowExtensions={["doc","docx","pdf","zip"]}
                              compClass="mobile-vertical"
                              typeV2
                              type="file"
                              title={
                                <>
                                  <span>Ek döküman yükle</span>
                                  <p>
                                    Kullanmak istediğiniz ünvanın işletmenize
                                    ait olduğunu kanıtlamak amacıyla ihtiyaç
                                    duyulabileceğini düşündüğünüz dökümanları
                                    eklemenizi öneririz.
                                  </p>
                                </>
                              }
                              icon={<UploadIcon />}
                            />
                          </Form.Item>
                        </Col>
                        <Col sm={24} md={24} lg={24} xl={12} span={24}>
                          <Form.Item
                            rules={[{ required: true }]}
                            name="add-document-2"
                            messageVariables={{ label: 'file-document' }}
                          >
                            <SelectFile
                             allowExtensions={["doc","docx","pdf","zip"]}
                              typeV2
                              typeName="file-2"
                              type="file"
                              title={
                                <>
                                  <span>Ticari faliyet belgesi yükle</span>
                                </>
                              }
                              icon={<UploadIcon />}
                            />
                          </Form.Item>
                        </Col>
                        <Col sm={24} md={24} lg={24} xl={12} span={24}>
                          <Form.Item
                            rules={[{ required: true }]}
                            name="add-document-3"
                            messageVariables={{ label: 'file-document' }}
                          >
                            <SelectFile
                             allowExtensions={["doc","docx","pdf","zip"]}
                              typeV2
                              typeName="file-3"
                              type="file"
                              title={
                                <>
                                  <span>Vergi levhası yükle</span>
                                </>
                              }
                              icon={<UploadIcon />}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </Col>
                <Col
                  md={24}
                  lg={{ span: 6, offset: 2 }}
                  xl={{ span: 6, offset: 2 }}
                  span={24}
                >
                  <div>
                    <MessagesSummary
                      compClass="mobile-type-2"
                      typeV2
                      identityInfo={
                        <>
                          Mehmet Özmen <br /> 52341231 <br /> H92 828282 <br />
                          10.02.1993
                        </>
                      }
                      companyInfo=""
                      necessaryInfo=""
                    />
                  </div>
                </Col>
              </Row>
            </div>
            {!isPc ? (
              <div className="step-transitions__right">
                <Button
                  type="ghost"
                  className="circle"
                  href="./CreateTitleStep1"
                >
                  <ArrowLeft />
                </Button>
                <Button
                  type="primary"
                  shape="round"
                  htmlType="submit"
                  className="ant-btn--icon"
                  onClick={() => {
                    setSelectTitleModal(true);
                  }}
                  disabled={!valid}
                >
                  Ünvanınızı Seçiniz
                  <ArrowRight />
                </Button>

                <Modal
                  title="Ünvan Seçin"
                  visible={selectTitleModal}
                  onCancel={() => setSelectTitleModal(false)}
                  footer={[
                    <div className="modal-action">
                      <Button
                        shape="round"
                        type="ghost"
                        onClick={() => setSelectTitleModal(false)}
                      >
                        Vazgeç
                      </Button>
                      <Button
                        key="confirm"
                        type="primary"
                        href={'../Title/success'}
                        onClick={() => {
                          setSelectTitleModal(false);
                        }}
                      >
                        Onaya Gönder
                      </Button>
                    </div>,
                  ]}
                >
                  <div>
                    <Form form={form} name="choose-title">
                      <Form.Item
                        rules={[{ required: true }]}
                        name="title"
                        messageVariables={{ label: 'title' }}
                      >
                        <Input
                          type="text"
                          name="Title"
                          label="Ünvanınız"
                          info={
                            <span>
                              Telefonda mesaj başlığı olarak görünecek gönderen
                              ismi.
                            </span>
                          }
                        />
                      </Form.Item>
                      <Form.Item
                        name="mail"
                        messageVariables={{ label: 'e-mail' }}
                      >
                        <Input type="mail" name="mail" label="Mail Adresiniz" />
                      </Form.Item>
                      <Form.Item name="chekbox" messageVariables="checkbox">
                        <Checkbox
                          text={
                            <>
                              <a href="javascript:;">Sözleşme</a>yi okudum,
                              kabul ediyorum ve yukarıdaki e-mail adresime
                              gönderilmesini talep ediyorum.
                            </>
                          }
                        />
                      </Form.Item>
                    </Form>
                  </div>
                </Modal>
              </div>
            ) : null}
          </div>
        </Form>
      </div>
      <Footer typeV2 />
    </Layout>
  );
};

export default ChooseTitle;
